import React, { ForwardedRef, forwardRef } from 'react';

import { Flex } from '@chakra-ui/react';

import { Divider } from 'uiToolkitV1/Divider';
import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

import { SectionContainer } from '../components/SectionContainer';
import { useGetLevelUpDetailsQuery } from '../dataHooks';

export const Details = forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => {
  const { data: levelUpCompetencyDetails, isLoading: isLevelUpLoading } = useGetLevelUpDetailsQuery();

  const formatDescription = (description: string) =>
    description.split('\n\n').map((text, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <TextBodyMedium key={index} mb={2}>
        {text}
      </TextBodyMedium>
    ));

  return (
    <SectionContainer ref={ref}>
      <TextBodyMedium bold mt={2} mb={4} mx={3}>
        Details
      </TextBodyMedium>
      <Divider borderColor="#CFD7DF" />
      <Flex flexDir="column" p={3} mt={3} gap={2} w="100%">
        <TextLabel color="text.g2">Description</TextLabel>
        {isLevelUpLoading ? (
          <SkeletonLoader />
        ) : (
          formatDescription(levelUpCompetencyDetails?.competencyDescription ?? '')
        )}
      </Flex>
    </SectionContainer>
  );
});
